/* eslint-disable operator-linebreak */
export const USER_IMAGE: string = "";
